/* eslint-disable radix */
import React from 'react'
import { useFetchContent } from 'src/hooks/useContentful/useFetchContent'
import { getSection } from 'src/hooks/useContentful/getSection'
import { useOffer } from '../../hooks/offer'
import CustomLink from '../CustomLink'
import Loading from '../Loading'

import * as S from './styles'

export default function Header() {
	const { currentOffer } = useOffer()
	const { data, isLoading } = useFetchContent()

	if (isLoading || !data) return <Loading />

	const { isGeneric } = data.fields
	const section = getSection({ sectionName: 'landingNav', data })
	const parceiroLogo = section.parceiroLogo.fields.file.url
	const veloeLogo = section.veloeLogo.fields.file.url

	return (
		<S.Container>
			<S.Content>
				<CustomLink to="/bradescoclassic" tagLabel="logo-veloe" parentComponent="menu">
					<S.ImgLogo>
						<img src={`https://${veloeLogo}`} alt={veloeLogo} />
					</S.ImgLogo>
				</CustomLink>
				{currentOffer && currentOffer.logo ? (
					<S.PartnerContainer>
						<S.PartnerImg src={currentOffer.logo} alt="Parceiro" />
					</S.PartnerContainer>
				) : !isGeneric && parceiroLogo ? (
					<S.PartnerContainer>
						<S.PartnerImg src={parceiroLogo} alt="Parceiro" />
					</S.PartnerContainer>
				) : null}
			</S.Content>
		</S.Container>
	)
}
